import React, {FC, ReactNode} from 'react'
import {Panel, PanelGroup} from 'react-resizable-panels'
import ContainerWrapper from '../Container'
import {ResizeHandle} from '../ResizeHandle/ResizeHandle'
interface Props {
  currentTab?: any
  renderPanelContent?: (e: any) => ReactNode | null
}

const PanelWrapper: FC<Props> = ({currentTab, renderPanelContent = null}) => {
  return (
    <ContainerWrapper>
      <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
        <Panel
          collapsible={true}
          order={1}
          key={`panel-central-header-${currentTab.id}`}
          id={`panel-central-header-${currentTab.id}`}
          className={'panel__box'}
          defaultSize={10}
        >
          <>{renderPanelContent?.(currentTab.content.headerPanel)}</>
        </Panel>
        <>
          {currentTab.showPanel && (
            <>
              <ResizeHandle />
              <Panel
                className={'panel__box'}
                collapsible={true}
                defaultSize={20}
                order={3}
                key={`panel-central-detail-${currentTab.id}`}
                id={`panel-central-detail-${currentTab.id}`}
              >
                {renderPanelContent?.(currentTab.content.detailPanel)}
              </Panel>
            </>
          )}
        </>
      </PanelGroup>
    </ContainerWrapper>
  )
}

export default PanelWrapper
